import { render, staticRenderFns } from "./addIngredientQuantityModalContent.vue?vue&type=template&id=0b096539&scoped=true"
import script from "./addIngredientQuantityModalContent.vue?vue&type=script&lang=js"
export * from "./addIngredientQuantityModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b096539",
  null
  
)

export default component.exports